import React from 'react';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import DockingWidget from './DockingWidget';
import Replayer from './Replayer';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  }
});

function Replay() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h5" component="h2">
            Replay
              </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Replayer />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <DockingWidget replayMode={true} />
        </Grid>
      </Grid>
    </div>
  );
}

export default Replay;
